var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .st0{fill:#ffffff;}  "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485.234,69.25H26.766C11.984,69.25,0,81.234,0,96v319.984c0,14.797,11.984,26.766,26.766,26.766h458.469 c14.781,0,26.766-11.969,26.766-26.766V96C512,81.234,500.016,69.25,485.234,69.25z M383.594,373.828 c0,8.5-6.906,15.422-15.422,15.422H66.844c-8.531,0-15.438-6.922-15.438-15.422V144.469c0-8.516,6.906-15.422,15.438-15.422 h301.328c8.516,0,15.422,6.906,15.422,15.422V373.828z M473.188,286.438h-45.125v-45.125h45.125V286.438z M449.047,186.766 c-13.906,0-25.172-11.281-25.172-25.188c0-13.922,11.266-25.188,25.172-25.188s25.172,11.266,25.172,25.188 C474.219,175.484,462.953,186.766,449.047,186.766z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.578,201.078c-0.672-0.406-1.531-0.422-2.234-0.031c-0.672,0.391-1.094,1.125-1.094,1.922v56.172v56.188 c0,0.797,0.422,1.531,1.094,1.922c0.703,0.391,1.563,0.375,2.234-0.031l94.109-56.172c0.672-0.391,1.078-1.125,1.078-1.906 c0-0.766-0.406-1.5-1.078-1.891L171.578,201.078z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.0d7b3776647efd486b838021f5fc32df.svg";
export { ForwardRef as ReactComponent };